import { Component, OnInit } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { AlertComponent } from '../../../shared/components/alert/alert.component';
import { LoadingComponent } from '../../../shared/components/loading/loading.component';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { InventoryService, FranchiseResultModel, VtexInventoryByFranchiseResponse } from '../../../core/services/inventory/inventory.service';
import {
  NgLabelTemplateDirective,
  NgOptionTemplateDirective,
  NgSelectComponent
} from '@ng-select/ng-select';
import {AccordionComponent} from '../../../shared/components/accordion/accordion.component';
import {AccordionItemComponent} from '../../../shared/components/accordion/accordion-item.component';

@Component({
  selector: 'app-inventory-franchise-search',
  imports: [FormsModule, AlertComponent, LoadingComponent, ButtonComponent, NgSelectComponent, NgOptionTemplateDirective, NgLabelTemplateDirective, AccordionComponent, AccordionItemComponent],
  templateUrl: './inventory-franchise-search.component.html',
  styleUrl: './inventory-franchise-search.component.scss'
})
export class InventoryFranchiseSearchComponent implements OnInit {
  searchType: 'SKU' | 'REF' = 'SKU';
  searchValue: string = '';
  franchises: FranchiseResultModel[] = [];
  selectedAccounts: string[] = [];
  loadingAccounts: boolean = false;

  loading: boolean = false;
  error: string | null = null;

  results: VtexInventoryByFranchiseResponse[] = [];
  expanded: Set<string> = new Set<string>();

  constructor(private readonly inventoryService: InventoryService) {}

  ngOnInit(): void {
    this.loadFranchises();
  }

  loadFranchises(): void {
    this.loadingAccounts = true;
    this.inventoryService.listFranchises().subscribe({
      next: (data) => {
        this.franchises = data || [];
        this.loadingAccounts = false;
      },
      error: (err) => {
        console.error(err);
        this.error = 'Falha ao carregar franquias.';
        this.loadingAccounts = false;
      }
    });
  }

  search(): void {
    this.error = null;
    this.results = [];

    const value = (this.searchValue || '').trim();
    if (!value) {
      this.error = 'Informe o valor para busca.';
      return;
    }

    // accounts: if includes 'ALL' or none selected, we send empty array to mean all
    let accounts = Array.isArray(this.selectedAccounts) ? this.selectedAccounts.filter(a => a !== 'ALL') : [];
    if (!accounts.length) {
      accounts = [];
    }

    const req: any = { accounts };
    if (this.searchType === 'SKU') {
      const n = Number(value);
      if (!Number.isInteger(n) || n <= 0) {
        this.error = 'SKU Id inválido.';
        return;
      }
      req.skuId = n;
    } else {
      req.refId = value;
    }

    this.loading = true;
    this.inventoryService.getInventory(req).subscribe({
      next: (res) => {
        this.results = res || [];
        // expand all by default when multiple
        // this.expanded = new Set(this.results.map(r => r.id));
        this.expanded = new Set();
        this.loading = false;
      },
      error: (err) => {
        console.error(err);
        if (err?.status === 404) {
          this.results = [];
          this.error = 'Nenhum inventário encontrado.';
        } else {
          this.error = 'Falha ao buscar inventário.';
        }
        this.loading = false;
      }
    });
  }

  toggle(franchiseId: string): void {
    if (this.expanded.has(franchiseId)) {
      this.expanded.delete(franchiseId);
    } else {
      this.expanded.add(franchiseId);
    }
    // Force change detection by creating a new Set reference
    this.expanded = new Set(this.expanded);
  }

  getAvailableTotal(r: VtexInventoryByFranchiseResponse): number {
    if (!r?.items?.length) return 0;
    return r.items.reduce((acc, it) => acc + ((it.totalQuantity || 0) - (it.reservedQuantity || 0)), 0);
  }
}
